import React from 'react';
import { useTranslation } from 'react-i18next';

import Inner from './Inner';

import { SEARCHKIT_PROMOTED_CONTENT_THEMES_FACET_PILLAR } from '../../../config/constants';

import './style.scss';

interface MenuItem {
  value: string;
  label: string;
  count: number;
  isRefined: boolean;
}

const SearchPromotedContentThemesPillarFacet: React.FC = () => {
  const { t } = useTranslation();

  const transformedItems = React.useCallback((items: MenuItem[]) => {
    items.unshift({
      value: '__all__',
      label: t('general.all'),
      count: 0,
      isRefined: false,
    });

    return items;
  // We only want to transform these items on mount, to prevent unnecessary rerenders.
  // However, linting wants to force us to add "t" as a dependency. That's why we disable it.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Inner
      attribute={SEARCHKIT_PROMOTED_CONTENT_THEMES_FACET_PILLAR}
      sortBy={['name:asc']}
      transformItems={transformedItems}
    />
  );
};

export default SearchPromotedContentThemesPillarFacet;
